export default {
    name: 'delDialog',
    data () {
        return {
            dialogDelVisible: this.value
        }
    },
    props: {
        value: {
            type: Boolean
        },
        tipsText: {
            type: String,
            default: '是否确认删除？'
        }
    },
    components: {},
    created () {},
    mounted () {},
    activated () {
    },
    deactivated() {},
    destroyed () {},
    watch: {
        value(newVal) {
            this.dialogDelVisible = newVal
        },
        dialogDelVisible(newVal) {
            this.$emit('input', newVal)
        },
    },
    computed: {},
    filters: {},
    methods: {
        submitDel(val) {
            this.$emit('submitDel', val)
        },
    }
}
/*
* export default {
  data () {
    return {}
  },
  components: {},
  created () {},
  mounted () {},
  activated () {
  },
  deactivated() {},
  destroyed () {},
  watch: {},
  computed: {},
  filters: {},
  methods: {
  }
}
*/